import { create } from "zustand";
import { PermissionsInterface, PermissionsSlice } from "./permissions";
import { createJSONStorage, persist } from "zustand/middleware";

export const usePermissionStore = create<PermissionsInterface>()((...a) => ({
  ...PermissionsSlice(...a),
}));
